import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig, EndpointParserFn } from '../../models/base-api-config.model';

export type DmVettingApiConfig = BaseApiConfig<{
  getSetting: string;
  updateSetting: string;
  disableSetting: string;
  getReport: EndpointParserFn;
}>;

export const DM_VETTING_API_CONFIG = new InjectionToken<DmVettingApiConfig>('DM_VETTING_API_CONFIG');

export const provideDmVettingApiConfig = (config: DmVettingApiConfig): StaticProvider => ({
  provide: DM_VETTING_API_CONFIG,
  useValue: config,
});
